import type { ComponentTemplatesFindQuery } from "schemas/generated/componentTemplates";

import * as React from "react";

import { componentTemplatesRouter } from "@v1/trpc/routes/componentTemplates";

export default function useInfiniteTemplates({
  storeId,
  componentCategoryType,
  componentCollectionId,
  searchText,
  pageSize,
  scope,
  includeComponent,
  selectedIndustries,
  selectedCategories,
  includeArchivedTemplates,
}: Omit<ComponentTemplatesFindQuery, "cursor">) {
  const queryParams = {
    storeId,
    componentCategoryType,
    componentCollectionId,
    searchText,
    pageSize,
    scope,
    includeComponent,
    selectedIndustries,
    selectedCategories,
    includeArchivedTemplates,
  };

  const { data, isLoading, fetchNextPage, isSuccess, isFetchingNextPage } =
    componentTemplatesRouter.find.useInfiniteQuery(queryParams, {
      getNextPageParam: ({ nextSkip }) => nextSkip ?? undefined,
    });

  const templatesFromServer = React.useMemo(() => {
    return data?.pages.map((page) => page.componentTemplates).flat();
  }, [data]);
  const pagesLength = data?.pages.length ?? 0;
  const pageData = data?.pages[pagesLength ? pagesLength - 1 : 0];
  const queryHasResults = pageData?.queryHasResults;
  const hasNextPage = Boolean(pageData?.nextSkip);

  return {
    fetchNextPage,
    componentTemplatesList:
      !isLoading && templatesFromServer ? templatesFromServer : null,
    isLoading,
    isLoadingInitialPage: !templatesFromServer,
    isSuccessComponentTemplates: isSuccess,
    hasNextPage,
    queryHasResults,
    isFetchingNextPage,
  };
}
